(function () {

    "use strict";

    angular
        .module("harriApp")
        .service("TeamLiveRequestsManagementDataService", TeamLiveRequestsManagementDataService);

    TeamLiveRequestsManagementDataService.$inject = ['$q', '$filter', 'TSUsersService', 'hUser', 'userPermissions'];

    /**
     * @namespace TeamLiveRequestsManagementDataService
     */
    function TeamLiveRequestsManagementDataService($q, $filter, TSUsersService, hUser, userPermissions) {
        var service = this;

        var tsUsers = {};
        var cachedTimeOffSettings = {};

        var defaultMetaData = {
            current_page: 0,
            last_page: null,
            per_page: 10,
            total: 0,
            offset: 0,
            limit: 10
        };

        var defaultRequestDetails = {};

        var requestDetails = {};

        var brandDaySettings = {};

        let requestLimitSettings = {};

        let defaultHolidayPlansCash = {};

        var payTypes = {
            'HOURLY': $filter('translate')('Hourly'),
            'HOURLY_FIXED': $filter('translate')('Hourly'),
            'HOURLY_FLEXIBLE': $filter('translate')('Hourly'),
            'WEIGHTED_SHIFT': $filter('translate')('Shift Based'),
            'SALARIED': $filter('translate')('Salaried')
        };

        service.ABSENCE_ERROR_CODES = {
            OVERLAPPING_SCHEDULE_SHIFTS: 'OVERLAPPING_SCHEDULE_SHIFTS',
            OVERLAPPING_REQUEST: 'OVERLAPPING_REQUEST',
            EXCEEDING_REQUESTS_LIMIT: 'EXCEEDING_REQUESTS_LIMIT',
        };

        service.holidayPlans = [];
        service.defaultHolidayPlans = [];
        service.payTypeNames = {};

        for (var key in payTypes) {
            service.payTypeNames[key] = payTypes[key];
        }

        service.getPayTypeName = function (key) {
            return service.payTypeNames[key] || '';
        };

        service.getHolidayPlans = function () {
            return service.holidayPlans;
        };

        service.getDefaultPlans = function () {
            return service.defaultHolidayPlans;
        };

        service.showErrorMessage = function (err, callback) {
            var errorBody = '<p>Something went wrong please try again later</p>';
            errorBody += '<p><pre>' + JSON.stringify(err, null, ' ') + '</pre></p>';

            hAlert(
                'Something went wrong!',
                errorBody,
                function () {
                    callback && callback();
                },
                'h-general-error-alert'
            );
        };

        service.showSuccessMessage = function (message) {};

        var generateError = function (reason) {};

        service.TYPES = [{
            code: 'CUSTOM',
            title: ''
        }, {
            code: 'HOLIDAY',
            title: 'Holiday'
        }, {
            code: 'SICKNESS',
            title: 'Sickness'
        }];

        service.statuses = [{
            code: 'PENDING_APPROVAL',
            title: 'Pending'
        }, {
            code: 'CLOSED',
            title: 'Closed'
        }, {
            code: 'APPROVED',
            title: 'Approved'
        }, {
            code: 'REJECTED',
            title: 'Rejected'
        }, {
            code: 'DELETED',
            title: 'Deleted'
        }, {
            code: 'WITHDRAWN',
            title: 'Withdrawn'
        }];

        service.requestTypePermission = {
            'ABSENCE_REQUESTS': userPermissions.PERMISSIONS.MANAGE_ABSENCE_REQUESTS,
            'AVAILABILITY_REQUESTS': userPermissions.PERMISSIONS.MANAGE_AVAILABILITY_REQUESTS,
            'TIMEOFF_REQUESTS': userPermissions.PERMISSIONS.MANAGE_TIMEOFF_REQUESTS
        };

        service.prepareUsersList = function (policyParser, users, requestType) {
            var requestEmployees = [];
            var currentUserId = hUser.getUser().team_user_id;
            var isEmployer = hUser.isEmployer();

            for (var i in users) {
                var user = users[i];
                var userPositions = user['positions'] || [];
                var positionsWithPermission = [];
                var userId = user.id;

                if (isEmployer && userId === currentUserId) {
                    requestEmployees.push(user);
                    continue;
                }

                for (var p in userPositions) {
                    var position = userPositions[p];
                    var canManagePositionsRequest;
                    canManagePositionsRequest = policyParser.positions(position.category.code, position.code).has(service.requestTypePermission[requestType]);

                    if (canManagePositionsRequest) {
                        positionsWithPermission.push(position);
                    }
                }
                if (positionsWithPermission.length && (positionsWithPermission.length === userPositions.length)) {
                    requestEmployees.push(user);
                }
            }
            return requestEmployees;
        };

        /**
         * This function used to handle absence requests data
         */
        var prepareData = function (requestData, brandId, isEmployer, allAbsences) {
            var requests = requestData;
            var data = [];

            for ( var i in requests ) {
                var request = requests[i];

                request.available_days = request.available_days || 0;

                var startDate = moment(request.start_date);
                var endDate = moment(request.end_date);

                var incidentDate;
                if (request.incident_date) {
                    incidentDate = moment(request.incident_date);
                }

                var totalDays = (Math.round((endDate.valueOf() - startDate.valueOf()) / (24 * 60 * 60 * 1000)) + 1);

                if (totalDays === 1 && request.days && !request.days[0].is_all_day) {

                    var fromTime = request.days[0].from_time;
                    var toTime = request.days[0].to_time;

                    if (toTime <= fromTime) {
                        toTime += 24 * 60 * 60;
                    }

                    var fromToDiff = toTime - fromTime;
                    var numberOfSeconds = parseInt(fromToDiff);
                    var fullHours = numberOfSeconds / (60 * 60);
                    var hours = Math.floor(fullHours);
                    var minutes = Math.round((((fullHours * 100) % 100) / 100) * 60) * 100 / 60 ;

                    if (minutes < 10) {
                        minutes = '0' + minutes;
                    }

                    totalDays = hours;
                    if (parseFloat(minutes) > 0) {
                        totalDays += '.' + parseInt(minutes);
                    }

                    if (
                        (parseFloat(hours) > 1 && parseFloat(minutes) >= 0) ||
                        (parseFloat(hours) === 0 && parseFloat(minutes) === 0) ||
                        (parseFloat(hours) === 1 && parseFloat(minutes) > 0)
                    ) {
                        totalDays += ' Hours';
                    } else {
                        totalDays += ' Hour';
                    }

                } else {
                    if (totalDays === 1) {
                        totalDays += ' Day';
                    } else if (totalDays > 1 || totalDays === 0) {
                        totalDays += ' Days';
                    }
                }

                var requestObj = {
                    id: request.id,
                    start: startDate.toDate(),
                    end: endDate.toDate(),
                    type: request.absence,
                    totalDays: totalDays,
                    user: request.employee,
                    isDeleteAble: startDate.toDate().valueOf() >= Date.now(),
                    startDateInfo: {
                        day_number: startDate.format('DD'),
                        day: startDate.format('ddd'),
                        month: startDate.format('MMM')
                    },
                    endDateInfo: {
                        day_number: endDate.format('DD'),
                        day: endDate.format('ddd'),
                        month: endDate.format('MMM')
                    },
                    attachments: request.attachments,
                    attachmentsCount: request.attachments_count,
                    status: request.status,
                    days: request.days,
                    reason: request.reason,
                    note: request.note,
                    created_by_user: request.created_by_user
                };

                if (incidentDate) {
                    requestObj['incident_date'] = incidentDate.toDate();
                }

                if (startDate.valueOf() === endDate.valueOf()) {

                    if (request.days[0].is_all_day) {
                        requestObj.period = 1;
                    } else {
                        requestObj.period = request.days[0].weight;
                    }
                } else {
                    requestObj.period = request.days.length;
                }

                switch (request.status) {
                    case 'PENDING_APPROVAL':
                        requestObj.availableDays = request.available_days;
                        requestObj.reason = request.reason;

                        if (!isEmployer) {
                            requestObj.canWithdraw = request.created_by_user.id === hUser.data.user.team_user_id;
                        }

                        break;

                    case 'APPROVED':

                        request.paid = request.paid || {};

                        requestObj.paidDays = request.paid.amount;

                        switch (request.paid.unit) {
                            case 'HOUR':
                                if (parseFloat(requestObj.paidDays) > 1 || parseFloat(requestObj.paidDays) === 0) {
                                    requestObj.paidDays += (' Hours');
                                } else{
                                    requestObj.paidDays += (' Hour');
                                }
                                break;

                            case 'SHIFT':
                                if (parseFloat(requestObj.paidDays) > 1 || parseFloat(requestObj.paidDays) === 0) {
                                    requestObj.paidDays += (' Shifts');
                                } else{
                                    requestObj.paidDays += (' Shift');
                                }
                                break;

                            case 'DAY':
                            default:
                                if (parseFloat(requestObj.paidDays) > 1 || parseFloat(requestObj.paidDays) === 0) {
                                    requestObj.paidDays += (' Days');
                                } else{
                                    requestObj.paidDays += (' Day');
                                }
                                break;
                        }

                        requestObj.approvedBy = request.employer;
                        requestObj.reason = request.reason;

                        if (!isEmployer) {

                            requestObj.submittedOn = new Date(request.submitted_on);
                            requestObj.canWithdraw = request.created_by_user.id === hUser.data.user.team_user_id && startDate.toDate().valueOf() >= Date.now();

                            if (requestObj.type === 'HOLIDAY') {
                                var weightSum = 0;

                                for (var i in request.days) {
                                    weightSum += request.days[i].weight || 0;
                                }

                                requestObj.allowanceUsed = weightSum;
                            }
                        }
                        break;

                    case 'REJECTED':
                        requestObj.rejectedBy = request.employer;
                        requestObj.rejectionStatus = $filter("translate")("Rejected");
                        requestObj.reason = request.reason;

                        break;

                    case 'DELETED':
                        requestObj.rejectedBy = request.employer;
                        requestObj.rejectionStatus = $filter("translate")("Deleted");
                        requestObj.reason = request.reason;

                        break;

                    case 'WITHDRAWN':
                        requestObj.rejectedBy = request.employee;
                        requestObj.rejectionStatus = $filter("translate")("Withdrawn");
                        requestObj.reason = request.reason;

                        break;

                    case 'CLOSED':
                        request.paid = request.paid || {};

                        requestObj.paidDays = request.paid.amount;

                        switch (request.paid.unit) {
                            case 'HOUR':
                                if (parseFloat(requestObj.paidDays) > 1 || parseFloat(requestObj.paidDays) === 0) {
                                    requestObj.paidDays += (' Hours');
                                } else{
                                    requestObj.paidDays += (' Hour');
                                }
                                break;

                            case 'SHIFT':
                                if (parseFloat(requestObj.paidDays) > 1 || parseFloat(requestObj.paidDays) === 0) {
                                    requestObj.paidDays += (' Shifts');
                                } else{
                                    requestObj.paidDays += (' Shift');
                                }
                                break;

                            case 'DAY':
                            default:
                                if (parseFloat(requestObj.paidDays) > 1 || parseFloat(requestObj.paidDays) === 0) {
                                    requestObj.paidDays += (' Days');
                                } else{
                                    requestObj.paidDays += (' Day');
                                }
                                break;
                        }

                        requestObj.approvedBy = request.employer;
                        requestObj.closedBy = request.employer;
                        requestObj.reason = request.reason;
                        break;
                }

                if (!isEmployer) {
                    requestObj.submittedOn = new Date(request.submitted_on);
                }

                if (allAbsences) {
                    requestDetails[brandId]['ALL'] = requestDetails[brandId]['ALL'] || angular.copy(defaultMetaData);
                    requestDetails[brandId]['ALL'].data = requestDetails[brandId]['ALL'].data || [];
                    requestDetails[brandId]['ALL'].data.push(requestObj);
                } else {
                    requestDetails[brandId][request.absence.type] = requestDetails[brandId][request.absence.type] || angular.copy(defaultMetaData);
                    requestDetails[brandId][request.absence.type][request.status] = requestDetails[brandId][request.absence.type][request.status] || {};
                    requestDetails[brandId][request.absence.type][request.status].data = requestDetails[brandId][request.absence.type][request.status].data || [];
                    requestDetails[brandId][request.absence.type][request.status].data.push(requestObj);
                }

                data.push(requestObj);
            }

            return data;
        };

        service.getAbsenceTypes = function (brand, justAbsences) {
            var allAbsencesTypes = ["PATERNITY", "BEREAVEMENT", "MATERNITY", "SHARED_PARENTAL", "ADOPTION", "UNAUTHORIZED", "SHARED_PARENTAL_ADOPTION", "PATERNITY_ADOPTION", "NEONATAL"];
            var activeBrandAbsences = justAbsences ? ["CUSTOM"] : ["CUSTOM", "HOLIDAY"];
            var absencesTypes = brand['brand_absences'].map(function (item) {
                return item.type;
            });

            absencesTypes = absencesTypes.filter(function (v,i) {
                return absencesTypes.indexOf(v) === i;
            });

            for (var i in allAbsencesTypes) {
                if (absencesTypes.indexOf(allAbsencesTypes[i]) > -1) {
                    activeBrandAbsences.push(allAbsencesTypes[i]);
                }
            }

            return activeBrandAbsences;
        };

        /**
         * This function used to get employer absence requests.
         */
        service.getAbsenceRequests = function (brandId, types, statuses, filters, offset, limit, isEmployer, allAbsences, brandBusinessDay) {
            var defer = $q.defer();
            var userIds;



            filters = filters || {};

            if (filters.user && filters.user.id) {
                userIds = [filters.user.id];
            }

            var absenceId;

            if (filters.reason) {
                if (Array.isArray(filters.reason)) {
                    absenceId = filters.reason;
                }
                else if (filters.reason.id) {
                    absenceId = [filters.reason.id];
                }
            }

            filters.timePeriod = filters.timePeriod || {};

            AttendanceAPI.getEmployerAbsenceView(
                brandId,
                types,
                statuses,
                _.pluck(filters.categories, 'code'),
                _.pluck(filters.positions, 'code'),
                userIds,
                absenceId,
                filters.timePeriod.fromDate,
                filters.timePeriod.toDate,
                filters.sort,
                offset,
                limit,
                isEmployer
            ).then(function (requestsAPIDetails) {
                requestDetails[brandId] = requestDetails[brandId] || angular.copy(defaultRequestDetails);
                var data = prepareData(requestsAPIDetails.requests, brandId, isEmployer, allAbsences);

                if (allAbsences) {
                    requestDetails[brandId]['ALL'] = requestDetails[brandId]['ALL'] || {};
                    requestDetails[brandId]['ALL'].data = requestDetails[brandId]['ALL'].data || [];
                    requestDetails[brandId]['ALL'].current_page = requestsAPIDetails.current_page;
                    requestDetails[brandId]['ALL'].last_page = requestsAPIDetails.last_page;
                    requestDetails[brandId]['ALL'].per_page = requestsAPIDetails.per_page;
                    requestDetails[brandId]['ALL'].total = requestsAPIDetails.total;
                    requestDetails[brandId]['ALL'].offset = offset || 0;
                    requestDetails[brandId]['ALL'].limit = limit || 10;

                } else {
                    for (var i in types) {
                        var type = types[i];

                        for (var j in statuses) {
                            var status = statuses[j];

                            requestDetails[brandId][type] = requestDetails[brandId][type] || {};
                            requestDetails[brandId][type][status] = requestDetails[brandId][type][status] || angular.copy(defaultMetaData);
                            requestDetails[brandId][type][status].data = requestDetails[brandId][type][status].data || [];
                            requestDetails[brandId][type][status].current_page = requestsAPIDetails.current_page;
                            requestDetails[brandId][type][status].last_page = requestsAPIDetails.last_page;
                            requestDetails[brandId][type][status].per_page = requestsAPIDetails.per_page;
                            requestDetails[brandId][type][status].total = requestsAPIDetails.total;
                            requestDetails[brandId][type][status].offset = offset || 0;
                            requestDetails[brandId][type][status].limit = limit || 10;
                        }
                    }
                }

                defer.resolve(data);
            }, function (error) {
                defer.reject(error);
            });

            return defer.promise;
        };

        service.clearStatusData = function (brandId, types, status) {
            for (var i in types) {
                if (requestDetails[brandId] && requestDetails[brandId][types[i]] && requestDetails[brandId][types[i]][status]) {
                    requestDetails[brandId][types[i]][status] = angular.copy(defaultMetaData);
                }
            }
        };

        service.getAbsenceRequestOffset = function (brandId, types, status) {

            for (var i in types) {
                var type = types[i];

                if (requestDetails[brandId] && requestDetails[brandId][type] && requestDetails[brandId][type][status]) {
                    return requestDetails[brandId][type][status].offset;
                }
            }

            return 0;
        };

        service.getAbsenceRequestLimit = function (brandId, types, status) {

            for (var i in types) {
                var type = types[i];

                if (requestDetails[brandId] && requestDetails[brandId][type] && requestDetails[brandId][type][status]) {
                    return requestDetails[brandId][type][status].limit;
                }
            }

            return 0;
        };

        service.getAbsenceRequestLastPage = function (brandId, types, status) {

            for (var i in types) {
                var type = types[i];

                if (requestDetails[brandId] && requestDetails[brandId][type] && requestDetails[brandId][type][status]) {
                    return requestDetails[brandId][type][status].last_page;
                }
            }

            return 0;
        };

        service.getAbsenceRequestCurrentPage = function (brandId, types, status) {

            for (var i in types) {
                var type = types[i];

                if (requestDetails[brandId] && requestDetails[brandId][type] && requestDetails[brandId][type][status]) {
                    return requestDetails[brandId][type][status].current_page;
                }
            }

            return 0;
        };

        service.getAbsenceReportCurrentPage = function (brandId) {
            if (requestDetails[brandId] && requestDetails[brandId]['ALL']) {
                return requestDetails[brandId]['ALL'].current_page;
            }

            return 0;
        };

        service.getAbsenceReportLastPage = function (brandId) {
            if (requestDetails[brandId] && requestDetails[brandId]['ALL']) {
                return requestDetails[brandId]['ALL'].last_page;
            }

            return 0;
        };

        service.getAbsenceReportLimit = function (brandId) {
            if (requestDetails[brandId] && requestDetails[brandId]['ALL']) {
                return requestDetails[brandId]['ALL'].limit;
            }

            return 0;
        };

        service.getAbsenceReportOffset = function (brandId) {
            if (requestDetails[brandId] && requestDetails[brandId]['ALL']) {
                return requestDetails[brandId]['ALL'].offset;
            }

            return 0;
        };

        /**
         * This method used to approve employee absence request.
         */
        service.approveEmployerAbsenceRequest = function () {
            var defer = $q.defer();
            /**
             * Implement remove employee absence request API.
             */

            defer.resolve();

            return defer.promise;
        };

        /**
         * This method used to remove employee sickness request.
         */
        service.removeAbsenceRequest = function (brandId, absenceId) {
            var defer = $q.defer();

            AttendanceAPI
                .removeEmployerAbsenceRequest(brandId, absenceId)
                .then(function (response) {
                    defer.resolve(response);
                }, function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        };

        /**
         * This method used to remove employee sickness request.
         */
        service.rejectAbsenceRequest = function (brandId, absenceId) {
            var defer = $q.defer();

            AttendanceAPI
                .rejectEmployerAbsenceRequest(brandId, absenceId)
                .then(function (response) {
                    defer.resolve(response);
                }, function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        };

        service.approveAbsenceRequest = function (brandId, absenceId, days) {
            var defer = $q.defer();

            AttendanceAPI
                .approveEmployerAbsenceRequest(brandId, absenceId, days)
                .then(function (response) {
                    defer.resolve(response);
                }, function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        };

        service.withdrawAbsenceRequest = function (brandId, absenceId) {
            var defer = $q.defer();

            AttendanceAPI
                .withdrawAbsenceRequest(brandId, absenceId)
                .then(function (response) {
                    defer.resolve(response);
                }, function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        };

        service.closeAbsenceRequest = function (brandId, absenceId) {
            var defer = $q.defer();

            AttendanceAPI
                .closeRequest(brandId, absenceId)
                .then(function (response) {
                    defer.resolve(response);
                }, function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        };

        /**
         * This method used to remove employee sickness request.
         */
        service.removeEmployerSicknessRequest = function () {
            var defer = $q.defer();
            /**
             * Implement remove employee sickness request API.
             */

            defer.resolve();

            return defer.promise;
        };

        /**
         * This method used to remove employee absence request.
         */
        service.removeEmployeeAbsenceRequest = function () {
            var defer = $q.defer();
            /**
             * Implement remove employee absence request API.
             */

            defer.resolve();

            return defer.promise;
        };

        /**
         * This method used to remove employee sickness request.
         */
        service.removeEmployeeSicknessRequest = function () {
            var defer = $q.defer();
            /**
             * Implement remove employee sickness request API.
             */

            defer.resolve();

            return defer.promise;
        };

        /**
         * This method to return users that loaded for brand from tsUsersService without calling an APIs
         */
        service.getTSUsersSync = function (brandId) {
            /**
             * Make sure to get the users from cache on tsUserService or on this service
             */
            tsUsers[brandId] = tsUsers[brandId] || TSUsersService.brandsUsers[brandId];

            return tsUsers[brandId];
        };

        /**
         * This method called on requests controller on employer side to load all the users and there profiles
         * And make sure to return users from cache
         * Note: this api not really return all users if any user return undefined this mean he is deactivated or not loaded yet
         * Use the service.loadTsUser method is you have any user undefined on main variable
         */
        service.getTSUsers = function (brandId) {
            var defer = $q.defer();

            tsUsers[brandId] = tsUsers[brandId] || {};

            if (Object.keys(tsUsers[brandId]).length) {
                defer.resolve(tsUsers[brandId]);
            } else {
                TSUsersService.loadBrandUsers(brandId)
                    .then(function (users) {
                        tsUsers[brandId] = users;

                        defer.resolve(tsUsers[brandId]);
                    }, function (reason) {
                        defer.reject(generateError(reason));
                    });
            }

            return defer.promise;
        };

        /**
         * This method to load user not loaded by getTSUsers method to make sure load users are not defined from the
         * first time
         */
        service.loadTSUser = function (brandId, userId) {
            var defer = $q.defer();

            tsUsers[brandId] = tsUsers[brandId] || {};
            tsUsers[brandId][userId] = tsUsers[brandId][userId] || TSUsersService.brandsUsers[brandId][userId];

            if (tsUsers[brandId][userId]) {
                defer.resolve(tsUsers[brandId][userId]);
            } else {
                TSUsersService
                    .loadUsers(brandId, [userId])
                    .then(function (users) {
                        tsUsers[brandId][userId] = users[userId];

                        defer.resolve(tsUsers[brandId][userId]);
                    });
            }

            return defer.promise;
        };

        /**
         * Return user sync without using any promises or load any api
         */
        service.loadTSUserSync = function (brandId, userId) {
            tsUsers[brandId] = tsUsers[brandId] || {};
            tsUsers[brandId][userId] = tsUsers[brandId][userId] || (TSUsersService.brandsUsers[brandId] && TSUsersService.brandsUsers[brandId][userId]);

            return tsUsers[brandId][userId];
        };

        service.getAbsenceSettingsHolidayPlans = function (brandId) {

            var defer = $q.defer();
            if (defaultHolidayPlansCash[brandId]) {
                defer.resolve(JSON.parse(JSON.stringify(defaultHolidayPlansCash[brandId])));
            } else {
                AttendanceAPI.getAbsenceSettingsHolidayPlans(brandId)
                    .then((response) => {
                        service.holidayPlans = response.holiday_plans;
                        defaultHolidayPlansCash[brandId] = response.holiday_plans;
                        defer.resolve(JSON.parse(JSON.stringify(defaultHolidayPlansCash[brandId])));
                    })
                    .catch((err) => {
                        defer.reject(err);
                    });
            }
            return defer.promise;
        };

        service.getDefaultHolidayPlans = function (brandId) {

            var defer = $q.defer();

            AttendanceAPI.getDefaultHolidayPlans(brandId)
                .then(function (response) {
                    service.defaultHolidayPlans = response.auto_assignment_rules;
                    defer.resolve(service.defaultHolidayPlans);
                })
                .catch(function (err) {
                    defer.reject(err);
                });

            return defer.promise;
        };

        service.addDefaultHolidayPlan = function (brandId, planId, payload) {
            var defer = $q.defer();

            AttendanceAPI.addDefaultHolidayPlan(brandId, planId, payload)
                .then(function (response) {
                    defer.resolve(response);
                })
                .catch(function (err) {
                    defer.reject(err);
                });

            return defer.promise;
        };

        service.updateDefaultHolidayPlan = function (brandId, planId, defaultPlan, payload) {
            var defer = $q.defer();

            AttendanceAPI.updateDefaultHolidayPlan(brandId, planId, defaultPlan, payload)
                .then(function (response) {
                    defer.resolve(response);
                })
                .catch(function (err) {
                    defer.reject(err);
                });

            return defer.promise;
        };

        service.deleteDefaultHolidayPlan = function (brandId, planId, defaultPlanId) {
            var defer = $q.defer();

            AttendanceAPI.deleteDefaultHolidayPlan(brandId, planId, defaultPlanId)
                .then(function (response) {
                    defer.resolve(response);
                })
                .catch(function (err) {
                    defer.reject(err);
                });

            return defer.promise;
        };

        service.recoverDefaultHolidayPlan = function (brandId, planId, defaultPlanId) {
            var defer = $q.defer();

            AttendanceAPI.recoverDefaultHolidayPlan(brandId, planId, defaultPlanId)
                .then(function (response) {
                    defer.resolve(response);
                })
                .catch(function (err) {
                    defer.reject(err);
                });

            return defer.promise;
        };

        service.addNewHolidayPlan = function (data, brandId) {

            var defer = $q.defer();

            AttendanceAPI.addNewHolidayPlan(data, brandId)
                .then(function (response) {
                    defer.resolve(response);
                }, function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        };

        service.loadPlanData = function (brandId, planId) {

            var defer = $q.defer();

            AttendanceAPI.loadPlanData(brandId, planId)
                .then(function (response) {
                    defer.resolve(response);
                }, function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        };

        service.saveDefaultPlan = function (brandId, planId) {

            var defer = $q.defer();

            AttendanceAPI.saveDefaultPlan(brandId, planId)
                .then(function (response) {
                    defer.resolve(response);
                }, function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        };

        service.updatePlan = function (data, brandId) {

            var defer = $q.defer();

            AttendanceAPI.updatePlan(data, brandId)
                .then(function (response) {
                    defer.resolve(response);
                }, function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        };

        service.deleteHolidayPlan = function (planId, brandId) {

            var defer = $q.defer();

            AttendanceAPI.deleteHolidayPlan(planId, brandId)
                .then(function (response) {
                    defer.resolve(response);
                }, function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        };

        service.isHolidayPlanHaveDefaultPlan = function (holidayPlan) {
            return service.defaultHolidayPlans.some(function(defaultPlan) {
                return defaultPlan.holiday_plan.id === holidayPlan.id;
            });
        };

        service.isHolidayPlanHaveActiveDefaultPlan = function (plan) {
            return service.defaultHolidayPlans.some(function (defaultPlan) {
                return (defaultPlan.status === 'ACTIVE' && defaultPlan.holiday_plan.id === plan.id);
            });
        };

        service.getSicknessSettings = function (brandId) {

            var defer = $q.defer();

            AttendanceAPI.getSicknessSettings(brandId)
                .then(function (response) {
                    defer.resolve(response);
                }, function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        };

        service.updateSicknessSettings = function (data, absenceId, brandId) {

            var defer = $q.defer();

            AttendanceAPI.updateSicknessSettings(data, absenceId, brandId)
                .then(function (response) {
                    defer.resolve(response);
                }, function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        };

        service.getAbsenceSettings = function (brandId, types) {
            var defer = $q.defer();

            AttendanceAPI.getAbsenceCustomSettings(brandId, types)
                .then(function (response) {
                    defer.resolve(response);
                })
                .catch(function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        };

        service.getAbsenceCustomSettings = function (brand) {
            var defer = $q.defer();
            var types = service.getAbsenceTypes(brand, true);

            service.getAbsenceSettings(brand.id, types)
                .then(function (response) {
                    defer.resolve(response);
                })
                .catch(function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        };

        service.isDisabledToEditHolidayRequest = function (todayDate, requestDate) {
            return moment(requestDate.end_time).isBefore(todayDate);
        }

        service.isDisabledToDeleteHolidayRequest = function (todayDate, requestDate) {
            return moment(requestDate.start_time).isSameOrBefore(todayDate);
        }

        service.updateAbsenceCustomSettings = function (data, brandId) {

            var defer = $q.defer();

            AttendanceAPI.updateAbsenceCustomSettings(data, brandId)
                .then(function (response) {
                    defer.resolve(response);
                }, function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        };

        service.getDaysSettings = function (brandId, types) {

            var defer = $q.defer();

            AttendanceAPI.getDaysSettings(brandId, types)
                .then(function (response) {
                    defer.resolve(response);
                }, function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        };

        service.getBusinessBrandsDays = function (brandId, types) {
            var defer = $q.defer();

            AttendanceAPI.getBusinessBrandsDays(brandId, types)
                .then(function (response) {
                    defer.resolve(response);
                }, function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        };

        service.updateBusinessBrandsDays = function (brandId, payload) {
            var defer = $q.defer();

            AttendanceAPI.updateBusinessBrandsDays(brandId, payload)
                .then(function (response) {
                    defer.resolve(response);
                }, function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        };

        service.updateDaysSettings = function (data, brandId) {

            var defer = $q.defer();

            AttendanceAPI.updateDaysSettings(data, brandId)
                .then(function (response) {
                    defer.resolve(response);
                }, function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        };

        service.getAbsenceReasons = function (brand, user) {
            var defer = $q.defer();
            var types = service.getAbsenceTypes(brand);

            AttendanceAPI.getAbsenceReasons(brand.id, user, types)
                .then(function (response) {
                    defer.resolve(response);
                }, function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        };

        service.getAbsenceTrackerReportReasons = function (brand, user) {
            var defer = $q.defer();
            var absenceTypes = service.getAbsenceTypes(brand);
            var types = ['SICKNESS'].concat(absenceTypes);

            AttendanceAPI.getAbsenceReasons(brand.id, user, types)
                .then(function (response) {
                    defer.resolve(response);
                }, function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        };

        service.getEmployees = function (brandId) {

            var defer = $q.defer();

            AttendanceAPI.getEmployees(brandId)
                .then(function (response) {
                    if (response.users) {
                        for (var i in response.users) {
                            response.users[i].name = [response.users[i].first_name, response.users[i].last_name].join(" ");
                            if (TSUsersService.isUserInLoa(response.users[i].id)) {
                                if (!response.users[i].indicators) {
                                    response.users[i].indicators = [];
                                }
                                response.users[i].indicators.push('LOA');
                            }
                        }
                    }
                    defer.resolve(response);
                }, function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        };

        service.createAbsenceRequest = function (data, brandId, user) {

            var defer = $q.defer();

            AttendanceAPI.createAbsenceRequest(data, brandId, user)
                .then(function (response) {
                    defer.resolve(response);
                }, function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        };

        service.createSicknessRequest = function (data, brandId, user) {

            var defer = $q.defer();

            AttendanceAPI.createSicknessRequest(data, brandId, user)
                .then(function (response) {
                    defer.resolve(response);
                }, function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        };

        service.getUploadAttachmentsUrl = function (userId, fileName, brandId) {

            var defer = $q.defer();

            AttendanceAPI.getUploadAttachmentsUrl(userId, fileName, brandId)
                .then(function (response) {
                    defer.resolve(response);
                }, function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        };

        service.getRequestDetails = function (brandId, requestId) {

            var defer = $q.defer();
            var promises = {};

            if (hUser.isEmployer()) {
                promises['requestDetails'] = AttendanceAPI.getRequestDetails(brandId, requestId);
            } else {
                promises['requestDetails'] = AttendanceAPI.getEmployeeRequestDetails(brandId, requestId);
            }

            $q.all(promises)
                .then(function (result) {
                    var response = result['requestDetails'];
                    var startDate = moment(response.start_date);
                    var endDate = moment(response.end_date);

                    response.available_days = response.available_days || 0;
                    response.start = startDate.toDate();
                    response.end = startDate.toDate();
                    response.type = response.absence;

                    var totalDays = (Math.round((endDate.valueOf() - startDate.valueOf()) / (24 * 60 * 60 * 1000)) + 1) + ' Days';

                    if (totalDays === 1 && response.days && !response.days[0].is_all_day) {
                        var fromToDiff = response.days[0].to_time - response.days[0].from_time;
                        var numberOfSeconds = parseInt(fromToDiff);
                        var fullHours = numberOfSeconds / (60 * 60);
                        var hours = Math.floor(fullHours);
                        var minutes = Math.round((((fullHours * 100) % 100) / 100) * 60);

                        if (hours < 10) {
                            hours = '0' + hours;
                        }

                        if (minutes < 10) {
                            minutes = '0' + minutes;
                        }

                        totalDays = (hours + ':' + minutes) + ' Hours';
                    }

                    response.totalDays = totalDays;

                    response.startDateInfo = {
                        day_number: startDate.format('DD'),
                        day: startDate.format('ddd'),
                        month: startDate.format('MMM')
                    };

                    response.endDateInfo = {
                        day_number: endDate.format('DD'),
                        day: endDate.format('ddd'),
                        month: endDate.format('MMM')
                    };

                    defer.resolve(response);
                }, function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        };

        service.closeSicknessRequest = function (data, requestId, brandId) {

            var defer = $q.defer();

            AttendanceAPI.closeSicknessRequest(data, requestId, brandId)
                .then(function (response) {
                    defer.resolve(response);
                }, function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        };

        service.loadHolidayPlanStats = function (brandId, userId, user) {

            var defer = $q.defer();

            AttendanceAPI.loadHolidayPlanStats(brandId, userId, user)
                .then(function (response) {
                    defer.resolve(response);
                }, function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        };

        service.getAbsenceDaysSettings = function (brandId, user) {

            var defer = $q.defer();

            AttendanceAPI.getAbsenceDaysSettings(brandId, user)
                .then(function (response) {
                    defer.resolve(response);
                }, function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        };

        service.getUserEffectiveHolidayPlan = function (brandId) {

            var defer = $q.defer();

            AttendanceAPI.getUserEffectiveHolidayPlan(brandId)
                .then(function (response) {
                    defer.resolve(response);
                }, function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        };

        service.getHolidayYear = function (brandId) {

            var defer = $q.defer();

            AttendanceAPI.getHolidayYear(brandId)
                .then(function (response) {
                    defer.resolve(response);
                }, function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        };

        service.loadAbsenceTimeOffSettings = function (brandId, type) {
            var defer = $q.defer();

            if (cachedTimeOffSettings[brandId] && cachedTimeOffSettings[brandId][type]) {
                defer.resolve(cachedTimeOffSettings[brandId][type]);
            } else {
                AttendanceAPI.loadAbsenceTimeOffSettings(brandId, type)
                    .then(function (response) {
                        cachedTimeOffSettings[brandId] = cachedTimeOffSettings[brandId] || {};
                        cachedTimeOffSettings[brandId][type] = response;
                        defer.resolve(cachedTimeOffSettings[brandId][type]);
                    })
                    .catch(function (error) {
                        defer.reject(error);
                    });
            }
            return defer.promise;
        };

        service.saveAbsenceTimeOffSettings = function (brandId, absenceType, payload) {

            var defer = $q.defer();

            AttendanceAPI.saveAbsenceTimeOffSettings(brandId, absenceType, payload)
                .then(function (response) {
                    defer.resolve(response);
                })
                .catch(function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        };

        service.editEmployeeAbsenceRequest = function (brandId, absenceId, startDate, endDate) {
            var defer = $q.defer();

            AttendanceAPI.editEmployeeAbsenceRequest(brandId, absenceId, startDate, endDate)
                .then(function (response) {
                    defer.resolve(response);
                }, function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        };

        service.updateRequestDetails = function (brandId, requestId, payload) {

            var defer = $q.defer();

            AttendanceAPI.updateRequestDetails(brandId, requestId, payload)
                .then(function (response) {
                    defer.resolve(response);
                }, function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        };

        service.loadEmployeeListOfReasons = function (brandId, types) {

            var defer = $q.defer();

            AttendanceAPI.loadEmployeeListOfReasons(brandId, types)
                .then(function (response) {
                    defer.resolve(response);
                }, function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        };

        service.checkRequestErrors = function (brandId, userId, user, payLoad, checkWarnings) {
            var defer = $q.defer();
            AttendanceAPI.checkRequestErrors(brandId, userId, user, payLoad)
                .then(function (response) {
                    if (hUser.isEmployer() && checkWarnings) {
                        defer.resolve(response['warnings'] || []);
                    } else {
                        defer.resolve(response['validation_errors'] || []);
                    }
                }, function (error) {
                    defer.reject(error);
                });
            return defer.promise;
        };

        service.checkOverlappedRequests = function (brandId, userId, user, payLoad) {

            var defer = $q.defer();

            service.checkRequestErrors(brandId, userId, user, payLoad)
                .then(function (response) {
                    var overlappedRequests = response.find(function (item) {
                        return item.type === 'OVERLAPPING_REQUEST';
                    });
                    overlappedRequests = overlappedRequests || {
                        requests: []
                    };
                    defer.resolve(overlappedRequests);
                }, function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        };

        service.checkPDSIsClosedRequests = function (brandId, userId, user, payLoad) {

            var defer = $q.defer();

            service.checkRequestErrors(brandId, userId, user, payLoad)
                .then(function (validationErrors) {
                    var closedPDSRequests = validationErrors.find(function (item) {
                        return item.type === 'PDS_CLOSED';
                    });
                    closedPDSRequests = closedPDSRequests || {
                        pay_sheets: []
                    };
                    defer.resolve(closedPDSRequests);
                }, function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        };

        service.checkWithinEmploymentPeriod = function (brandId, userId, user, payLoad) {

            var defer = $q.defer();

            service.checkRequestErrors(brandId, userId, user, payLoad)
                .then(function (validationErrors) {
                    var employmentPeriodResponse = validationErrors.find(function (item) {
                        return item.type === 'DATES_OUTSIDE_EMPLOYMENT_PERIOD';
                    });
                    defer.resolve(employmentPeriodResponse && employmentPeriodResponse.employment_period);
                }, function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        };

        service.getAbsenceRequestHistory = function (brandId, requestId) {
            var defer = $q.defer();
            AttendanceAPI.getAbsenceRequestHistory(brandId, requestId).then(function (response) {
                defer.resolve(response);
            }, function (err) {
                defer.reject(err)
            });
            return defer.promise;
        };

        service.prepareAbsenceRequestHistoryData = function (data) {
            var history = _.groupBy(data, function (audit) {
                return moment(audit.audit_datetime).format('DD-MM-YYYY')
            });

            var dateFormat = 'ddd, MMM D, YYYY';
            for (var i in history) {
                var audits = history[i];
                for (var j = 0; j < audits.length; j++) {
                    audits[j].audit_date = moment(audits[j].audit_datetime).format('ddd, MMM D, YYYY');
                    audits[j].audit_time = $filter("formatDateIgnoreTimeZone")(audits[j].audit_datetime, 'hh:mm A');
                    audits[j].new = audits[j].new || {};
                    audits[j].old = audits[j].old || {};
                    var isExternalAction = audits[j].source === 'EXTERNAL';
                    if (audits[j].action === 'CREATE') {
                        audits[j].description = [];
                        if (audits[j].new.status === 'APPROVED') {
                            var createApprovedDesc = 'Submitted & approved  a new ' + audits[j].new.brand_absence.title +
                                ' request starting on ' + moment(audits[j].new.start_date).format(dateFormat) + ', ending on ' +
                                moment(audits[j].new.end_date).format(dateFormat) + '.';
                            if (audits[j].new.note) {
                                createApprovedDesc += ' Reason: ' + audits[j].new.note + '.';
                            }
                            audits[j].description.push(createApprovedDesc);
                        } else if (audits[j].new.status === 'PENDING_APPROVAL' || !audits[j].new.status) {
                            var createPendingDes = 'Submitted a new ' + audits[j].new.brand_absence.title + ' request starting on ' +
                                moment(audits[j].new.start_date).format(dateFormat) + ', ending on ' + moment(audits[j].new.end_date).format(dateFormat) + '.';
                            if (audits[j].new.reason) {
                                createPendingDes += ' Reason: ' + audits[j].new.reason + '.';
                            }
                            audits[j].description.push(createPendingDes);
                        }
                    } else if (audits[j].action === 'UPDATE') {
                        audits[j].description = [];
                        var oldRequest = audits[j].old;
                        var newRequest = audits[j].new;
                        if (newRequest.start_date !== oldRequest.start_date) {
                            audits[j].description.push('Modified the request start date from ' + moment(oldRequest.start_date).format(dateFormat) + ' to ' + moment(newRequest.start_date).format(dateFormat) + '.');
                        }
                        if (newRequest.end_date !== oldRequest.end_date) {
                            audits[j].description.push('Modified the request end date from ' + moment(oldRequest.end_date).format(dateFormat) + ' to ' + moment(newRequest.end_date).format(dateFormat) + '.');
                        }
                        if (newRequest.note !== oldRequest.note) {
                            if (newRequest.note && oldRequest.note) {
                                audits[j].description.push('Modified the employer note from ' + oldRequest.note + ' to ' + newRequest.note + '.');
                            } else if (newRequest.note) {
                                audits[j].description.push('Modified the employer note to ' + newRequest.note + '.');
                            } else {
                                audits[j].description.push('Employer note removed.');
                            }
                        }
                        if (newRequest.status !== oldRequest.status) {
                            const actor = isExternalAction ? 'System' : (audits[j].actor ? (`${audits[j].actor.first_name} ${audits[j].actor.last_name}`) : '');

                            if (newRequest.status === 'WITHDRAWN') {
                                audits[j].description.push('Withdrew the request.');
                            } else if (newRequest.status === 'REJECTED') {
                                audits[j].description.push(actor + ' rejected the request.');
                            } else if (newRequest.status === 'CLOSED') {
                                audits[j].description.push(actor + ' closed the request.');
                            } else if (newRequest.status === 'DELETED') {
                                audits[j].description.push(actor +' deleted the request.');
                            } else if (newRequest.status === 'APPROVED') {
                                audits[j].description.push(`${actor} ${$filter('translate')('approved the request')}.`);
                            }
                        }
                        if (newRequest.days && oldRequest.days) {

                            var newDaysTotal = 0;
                            for (var k in newRequest.days) {
                                if(newRequest.days[k].hasOwnProperty('weight')) {
                                    newDaysTotal += newRequest.days[k].weight;
                                }
                            }

                            var oldDaysTotal = 0;
                            for (var k in oldRequest.days) {
                                if(oldRequest.days[k].hasOwnProperty('weight')) {
                                    oldDaysTotal += oldRequest.days[k].weight;
                                }
                            }

                            if (newDaysTotal !== oldDaysTotal) {
                                audits[j].description.push('Updated the request paid days total number from ' + oldDaysTotal + ' to ' + newDaysTotal + '.');
                            } else if (newRequest.days.length === 1 && oldRequest.days.length === 1) {
                                var newFromTime = null;
                                var oldFromTime = null;
                                var newToTime = null;
                                var oldToTime = null;
                                if (newRequest.days[0].from_time) {
                                    newFromTime = moment().startOf("day").add(newRequest.days[0].from_time, 's').format('hh:mm A');
                                }

                                if (newRequest.days[0].to_time) {
                                    newToTime = moment().startOf("day").add(newRequest.days[0].to_time, 's').format('hh:mm A');
                                }

                                if (oldRequest.days[0].from_time) {
                                    oldFromTime = moment().startOf("day").add(oldRequest.days[0].from_time, 's').format('hh:mm A');
                                }

                                if (oldRequest.days[0].to_time) {
                                    oldToTime = moment().startOf("day").add(oldRequest.days[0].to_time, 's').format('hh:mm A');
                                }

                                if(oldFromTime && oldToTime && !newFromTime && !newToTime){

                                }

                                if (newToTime && oldToTime && newToTime !== oldToTime) {
                                    audits[j].description.push('Modified the request end time from ' + oldToTime + ' to ' + newToTime);
                                } else if (newToTime && !oldToTime) {
                                    audits[j].description.push('Modified the request end time to ' + newToTime);
                                }
                            }
                        }
                        if(!audits[j].description.length){
                            audits.splice(j,1);
                            j--;
                        }
                    }
                }
            }
            return history;
        };

        service.getPaySheetPeriods = function (brandId, userId, startDate, endDate) {
            var defer = $q.defer();
            var params = {
                start_date: moment(startDate).format('YYYY-MM-DD'),
                end_date: moment(endDate).format('YYYY-MM-DD'),
            };
            PerformanceAggregatorAPI.getPayPeriodsStatuses(brandId, userId, params).then(function (data) {
                defer.resolve(data.paysheets);
            });
            return defer.promise;
        };

        service.isDateFallInClosedPDS = function (date, paysheets) {
            return paysheets.some(function(paysheet) {
                return (paysheet.status === 'SENT' || paysheet.status === 'CLOSED') && service.isDateInRange(date, paysheet.start_date, paysheet.end_date);
            });
        };

        service.isDateInRange = function (date, startDate, endDate) {
            return moment(date).isSameOrAfter(startDate, 'day') && moment(date).isSameOrBefore(endDate, 'day');
        };

        service.getClosedPaySheetWithinDates = function (brandId, userId, startDate, endDate) {
            var defer = $q.defer();
            var start = moment(startDate);
            var end = moment(endDate);
            service.getPaySheetPeriods(brandId, userId, startDate, endDate).then(function (paysheets) {
                    for (var i = 0; i < paysheets.length; i++) {
                        if (['CLOSED', 'SENT'].indexOf(paysheets[i].status) > -1) {
                            if (start.isSameOrAfter(moment(paysheets[i].start_date)) && start.isSameOrBefore(moment(paysheets[i].end_date))) {
                                defer.resolve(paysheets[i]);
                                return;
                            }
                            if (end.isSameOrAfter(moment(paysheets[i].start_date)) && end.isSameOrBefore(moment(paysheets[i].end_date))) {
                                defer.resolve(paysheets[i]);
                                return;
                            }
                        }
                    }
                    defer.resolve(null);
                }
            );
            return defer.promise;
        };

        service.checkIfDateRangeWithinBlockedDays = function (daysSettings, requestStartDate, requestEndDate) {
            var blockedDays = daysSettings.days;
            var startDate, endDate;
            var dateRangeBlocked = false;

            if (daysSettings.blocked_days_enabled && blockedDays && blockedDays.length) {
                startDate = moment(moment(requestStartDate).format("MMM DD, YYYY")).valueOf();
                endDate = moment(moment(requestEndDate).format("MMM DD, YYYY")).valueOf();

                for (var day in blockedDays) {
                    var blockedDay = blockedDays[day];
                    var blockedStartDate = moment(blockedDay.start_time).valueOf();
                    var blockedEndDate = moment(blockedDay.end_time).valueOf();
                    var blockedDaysPeriod = (blockedEndDate - blockedStartDate) / 1000 / 3600;
                    var blockedStart = moment(moment(blockedDay.start_time).format("MMM DD, YYYY")).valueOf();

                    if (
                        blockedDaysPeriod <= 24 &&
                        (
                            startDate === blockedStart ||
                            endDate === blockedStart ||
                            (startDate < blockedStart && endDate > blockedStart)
                        )

                    ) {
                        dateRangeBlocked = true;
                        break;
                    } else {
                        if (
                            (startDate >= blockedStartDate && startDate <= blockedEndDate) ||
                            (endDate >= blockedStartDate && endDate <= blockedEndDate) ||
                            (startDate < blockedStartDate && endDate > blockedEndDate)
                        ) {
                            dateRangeBlocked = true;
                            break;
                        }
                    }
                }
            }

            return dateRangeBlocked;
        };

        service.handleTimeOffOrAbsenceEmployerWarnings = function (overlapScheduleShiftsCode, data, dateRangeBlocked, type, mode, saveCallback, cancelCallback, editAbsencePayload) {
            var defer = $q.defer();
            var confirmationTitle = [
                $filter('translate')(Utils.capitalize(mode)),
                $filter('translate')(Utils.capitalize(type)),
                $filter('translate')('Request'),
                '?'
            ].join(' ');
            var confirmationMessage = '';

            if (dateRangeBlocked) {
                confirmationMessage = $filter('translate')('Note that the date range includes days with blocked days') + '.';
            } else if (!!overlapScheduleShiftsCode) {
                confirmationMessage = [
                    Utils.capitalize(data.employee_name),
                    $filter('translate')('is scheduled on week(s) that will overlap with this new'),
                    $filter('translate')(type),
                    $filter('translate')('request submission'),
                    '.'
                ].join(' ');
            }

            confirmationMessage += [
                '',
                $filter('translate')('Are you sure you want to proceed with'),
                mode === 'submit' ? $filter('translate')('adding') : $filter('translate')('editing'),
                $filter('translate')('this'),
                $filter('translate')(type),
                $filter('translate')('request'),
                '?',
            ].join(' ');

            Utils.hConfirm({
                title: confirmationTitle,
                confirmButton: $filter("translate")("Continue"),
                cancelButton: $filter("translate")("Cancel"),
                text: confirmationMessage,
                callback: function (confirmed) {
                    if (confirmed) {
                        var payload = data;

                        if (type === 'absence' && mode === 'edit') {
                            payload = editAbsencePayload;
                        }
                        saveCallback && saveCallback(payload)
                            .then(function () {
                                defer.resolve('CONFIRM_REQUEST');
                            })
                            .catch(function (err) {
                                console.error(err);
                                defer.reject(err);
                            });
                    } else {
                        cancelCallback && cancelCallback();
                        defer.reject('CANCEL_REQUEST');
                    }
                }
            });

            return defer.promise;
        };

        service.checkAbsenceRequestErrors = function (data, brandId, mode, blockedDaysSettings, callback, editPayload) {
            var defer = $q.defer();
            var dateRangeBlocked = service.checkIfDateRangeWithinBlockedDays(blockedDaysSettings, data.start_date, data.end_date);

            var checkWarningsPayload = {
                request: {
                    start_date: data.start_date && moment(data.start_date).format('YYYY-MM-DD'),
                    end_date: data.end_date && moment(data.end_date).format('YYYY-MM-DD'),
                    absence: data.absence,
                    days: data.days
                }
            };

            if (data.absence && data.absence.type === 'HOLIDAY') {
                service.checkRequestErrors(brandId, data.employee.id, {isEmployer: true}, checkWarningsPayload, true)
                    .then(function (requestWarnings) {
                        var overlapScheduleShiftsCode = _.findWhere(requestWarnings, {type: service.ABSENCE_ERROR_CODES.OVERLAPPING_SCHEDULE_SHIFTS});
                        var method;

                        if (!!overlapScheduleShiftsCode || dateRangeBlocked) {
                            method = service.handleTimeOffOrAbsenceEmployerWarnings(overlapScheduleShiftsCode, data, dateRangeBlocked, 'absence', mode, callback, null, editPayload);
                        } else {
                            method = mode === 'edit' ? callback(editPayload) : callback(data);
                        }

                        method
                            .then(function (res) {
                                defer.resolve(res);
                            })
                            .catch(function (err) {
                                console.error(err);
                                defer.reject(err);
                            });
                    })
                    .catch(function (err) {
                        console.error(err);
                        defer.reject(err);
                    });

            } else if (dateRangeBlocked) {
                service.handleTimeOffOrAbsenceEmployerWarnings(null, data, dateRangeBlocked, 'absence', mode, callback, null, editPayload)
                    .then(function (res) {
                        defer.resolve(res);
                    })
                    .catch(function (err) {
                        console.error(err);
                        defer.reject(err);
                    });

            } else {
                var callbackPayload = mode === 'edit' ? editPayload : data;

                callback(callbackPayload)
                    .then(function (res) {
                        defer.resolve(res);
                    })
                    .catch(function (err) {
                        console.error(err);
                        defer.reject(err);
                    });
            }

            return defer.promise;
        };

        service.checkIfHasEffectiveLOA = function (brandId) {
            var defer = $q.defer();
            var userId = hUser.data.user.team_user_id;

            if (TSUsersService.users[userId]) {
                defer.resolve(TSUsersService.isUserInLoa(userId));
            } else {
                TSUsersService.loadUsers(brandId, [userId])
                    .then(function () {
                        defer.resolve(TSUsersService.isUserInLoa(userId));
                    })
                    .catch(function (err) {
                        console.error(err);
                        defer.reject(err);
                    });
            }

            return defer.promise;
        };

        service.getBrandAbsenceReasons = function (brandId, type, status) {
            var defer = $q.defer();

            AttendanceAPI.getBrandAbsenceReasons(brandId, type, status)
                .then(function (response) {
                    defer.resolve(response);
                }, function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        };

        service.updateBrandAbsenceReasons = function (brandId, type, data) {
            var defer = $q.defer();

            AttendanceAPI.updateBrandAbsenceReasons(brandId, type, data)
                .then(function (response) {
                    defer.resolve(response);
                }, function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        };

        service.setBrandDaySettings = function (settings) {
            brandDaySettings = settings;
        };

        service.setRequestLimitSettings = function (settings, absenceType) {
            requestLimitSettings[absenceType] = settings;
        }

        service.isRequestLimitOrgSettingEnabled = function (absenceType) {
            return requestLimitSettings[absenceType]?.enabled && requestLimitSettings[absenceType].manage_mode === 'BUSINESS';
        }

        service.showHolidayFormActions = function (isHmapSettingsForm, brand, holidayType) {
            var isHighestParent = brand.id === brand.parent_id;
            var isBrandDaySettingsEnabled = service.isBrandDaySettingsEnabled(holidayType);

            return (
                (!isHmapSettingsForm && isBrandDaySettingsEnabled && isHighestParent) ||
                (!isHmapSettingsForm && !isBrandDaySettingsEnabled) ||
                (isHmapSettingsForm && isBrandDaySettingsEnabled)
            );
        };

        service.getHolidayTypesForCountryCodes = function (countryCodes) {
            var holidayTypes = {
                PH: ['REGULAR_HOLIDAY', 'SPECIAL_NON_WORKING_DAY', 'BLOCKED'],
                UK: ['COMPANY_HOLIDAY', 'STATUTORY_HOLIDAY', 'BLOCKED'],
                US: ['BLOCKED']
            };

            var uniqueHolidayTypes = [];

            for (var i = 0; i < countryCodes.length; i++) {
                var code = countryCodes[i];
                var types = holidayTypes[code];

                if (types !== undefined) {
                    for (var j = 0; j < types.length; j++) {
                        var type = types[j];

                        if (uniqueHolidayTypes.indexOf(type) === -1) {
                            uniqueHolidayTypes.push(type);
                        }
                    }
                }
            }

            return uniqueHolidayTypes;
        };

        service.isBrandDaysContainsHoliday = function (brandDays, holidayType) {
            return brandDays && brandDays.some(function(day) {
                return day.type === holidayType;
            });
        };

        service.isBrandDaySettingsEnabled = function (holidayType) {
            var brandDays = brandDaySettings && brandDaySettings.brand_days;
            var blockedHolidaysSetting = service.isBrandDaysContainsHoliday(brandDays, holidayType);

            return (
                brandDaySettings.enabled &&
                brandDaySettings.manage_mode === 'BUSINESS' &&
                blockedHolidaysSetting
            );
        };

        service.reset = function () {
            cachedTimeOffSettings = {};
            defaultHolidayPlansCash = {};
        };

        return service;
    }

})();